import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output} from "@angular/core";
import * as _ from "lodash";

require('./planning-draft-routes-table-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-routes-table-list-item',
  templateUrl: './planning-draft-routes-table-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftRoutesTableListItemComponent implements OnInit, OnChanges {
  public isShowCopyBtn: boolean = false;
  @Input() route: any;
  @Input() logisticsVehicleName?: string;
  @Input() resource: any;
  @Input() settings: any;
  @Input() isVisible: boolean;
  @Input() isSelected: boolean;
  @Input() canClose: boolean;
  @Input() isShowActionMenu: boolean;
  @Input() itemElementSize: string;
  @Input() isGroupedRoutes: boolean;

  @Output() onDispatch = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onFeedback = new EventEmitter<{ routeId: string, feedback: string }>();
  @Output() onClose = new EventEmitter<void>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onReoptimize = new EventEmitter<string>();
  @Output() onPreAssignAgent = new EventEmitter<string>();
  @Output() onLockRouteChange = new EventEmitter<{id: string, locked: boolean}>();
  @Output() onToggleVisible = new EventEmitter<boolean>();
  @Output() onEditResourceAllocation = new EventEmitter<{route: any, event: any}>();
  @Output() onChangeRouteResource = new EventEmitter<{routeId: string, event: any}>();
  @Output() onToggleSelected = new EventEmitter<boolean>();
  @Output() onToggleGroupedRoutes = new EventEmitter<void>();

  public dateRange: { notBefore: string; notAfter: string };

  constructor() {}

  ngOnInit() {
    this.setDateRange();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.route) {
      this.setDateRange();
    }
  }

  private setDateRange() {
    this.dateRange = {
      notBefore: _.get(_.head(this.route?.activities), 'eta'),
      notAfter: _.get(_.last(this.route?.activities), 'etd')
    };
  }

  getRouteColor() {
    return this.route?.color || '#3366ff';
  }

  getRouteIsRunning() {
    return this.route?.actionProcess?.running && (new Date().getTime() < this.route.actionProcess?.expirationDate);
  }

  onChangeRouteResourceClick(event: any) {
    this.onChangeRouteResource.emit({routeId: this.route?.id, event: event});
  }
}

